var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vehicle-plate"},[_c('span',{staticClass:"text-xs-center",class:{caption: _vm.overline, 'd-block': _vm.block}},[_vm._v(_vm._s(_vm.plate))])])}
var staticRenderFns = []

export { render, staticRenderFns }